<div #pageTitleContainer class="page-title-container">
  <img class="headerpic" src="{{imgPath}}">
  <div class="headerText">{{title}}</div>
</div>
